import { css } from '@emotion/css';
import { colors } from 'constants/theme';

const addBankStyles = {
    wrap: css`
        background: ${colors.white};
        color: ${colors.black};
        overflow: hidden;
        box-shadow: 1px 1px 50px rgba(0, 0, 0, 0.3);
    `,
    heading: css`
        position: relative;
        height: 42px;
        display: flex;
        align-items: center;
        background-color: #f8f8f8;
        border-bottom: 1px solid #eee;
        padding: 0 80px 0 20px;
        h6 {
            font-size: 14px;
            font-weight: 400;
            color: #333;
        }
        button {
            display: flex;
            position: absolute;
            top: 12px;
            right: 14px;
            cursor: pointer;
        }
    `,
    breadcrumb: css`
        display: flex;
        width: 100%;
        overflow: hidden;
        margin: 20px 0;
        justify-content: space-between;
        padding: 0 8px;
    `,
    breadItem: css`
        height: 48px;
        flex: 0 0 calc(50% - 12px);
        background: #32343b;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        p {
            padding-left: 16px;
        }
        &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;

            border-left: 18px solid ${colors.blackText};
            border-top: 24px solid transparent;
            border-bottom: 24px solid transparent;
        }
        &::after {
            content: '';
            position: absolute;
            top: 0;
            right: -18px;

            border-left: 18px solid #32343b;
            border-top: 24px solid transparent;
            border-bottom: 24px solid transparent;
        }
        &.active {
            background: ${colors.primary};
            &::after {
                border-left-color: ${colors.primary};
            }
        }
    `,
    breadItem1: css`
        z-index: 2;
    `,
    breadItem2: css`
        transform: translateX(-18px);
    `,
    noteConfirm: css`
        color: #d90500;
        font-size: 17px;
        font-weight: 300;
    `,
    viewConfirm: css`
        padding-left: 20px;
        padding-right: 20px;
        padding-top: 20px;
        padding-bottom: 20px;
    `,
    infoBankList: css`
        margin-bottom: 22px;
        margin-top: 30px;
    `,
    infoBankItem: css`
        display: flex;
        align-items: center;
        gap: 12px;
        p {
            font-size: 15px;
            margin-bottom: 8px;
            &:first-child {
                text-align: right;
                font-weight: 300;
                width: 300px;
            }
            &:last-child {
                padding: 10px;
                font-weight: 500;
            }
        }
        .bankCard {
            padding: 10px;
            background: ${colors.black};
            font-weight: 500;
            color: white;
            border-radius: 8px;
            text-align: left;
            font-size: 16px;
        }
        .btnBankCard {
            border: 1px solid #c9820a !important;
            border-radius: 3px !important;
            color: #fff !important;
            background: linear-gradient(to bottom, #ffffff 0%, #ffc857 2%, #ffad33 100%);
            width: 300px;
            padding-top: 10px;
            padding-bottom: 10px;
            margin-top: 20px;
        }
    `,
    formAddBank: css`
        max-height: 646px;
        overflow-y: auto;
        padding: 26px 0 28px;
        display: flex;
        flex-direction: column;

        &::-webkit-scrollbar-thumb {
            background: #32343b;
        }

        .titleValue {
            width: 30%;
            display: flex;
            justify-content: flex-end;
            padding-right: 15px;
        }
    `,
    channelTypeSelector: css`
        display: flex;
        align-items: center;
        min-height: 50px;
        margin-bottom: 20px;
        padding-bottom: 15px;
        border-bottom: 1px solid #e0e0e0;
        label:first-child {
            width: 30%;
            padding-right: 15px;
            text-align: right;
            font-weight: 500;
            color: #333;
        }
        .channel-radio-group {
            width: 35%;
            display: flex;
            gap: 20px;
            align-items: center;
        }
        .channel-radio-group input[type='radio'] {
            display: none;
        }
        .channel-radio-group label {
            display: flex;
            align-items: center;
            justify-content: center;
            min-width: 120px;
            margin-right: 20px;
            padding: 12px 20px;
            border: 2px solid #e0e0e0;
            border-radius: 8px;
            background-color: #fff;
            color: #666;
            font-weight: 500;
            white-space: nowrap;
            cursor: pointer;
            transition: all 0.3s ease;
        }
        .channel-radio-group label::before {
            content: '';
            width: 16px;
            height: 16px;
            margin-right: 8px;
            border: 2px solid #e0e0e0;
            border-radius: 50%;
            background-color: white;
            transition: all 0.3s ease;
            flex-shrink: 0;
        }
        .channel-radio-group input[type='radio']:checked + label {
            border-color: #4285f4;
            color: #4285f4;
            background-color: #f8fbff;
        }
        .channel-radio-group input[type='radio']:checked + label::before {
            border-color: #4285f4;
            background-color: #4285f4;
            box-shadow: inset 0 0 0 3px #fff;
        }
        .channel-radio-group label:hover {
            border-color: #4285f4;
            background-color: #f8fbff;
        }
    `,
    groupInput: css`
        display: flex;
        min-height: 72px;
        align-items: center;
        p {
            font-weight: 300;
        }
    `,
    btnSubmit: css`
        border: 1px solid #c9820a !important;
        border-radius: 3px !important;
        color: #fff !important;
        background: linear-gradient(to bottom, #ffffff 0%, #ffc857 2%, #ffad33 100%);
        /* padding-left: 10px;
        padding-right: 10px; */
        text-align: center;
        display: flex;
        height: 40px;
        align-items: center;
        cursor: pointer;
        align-self: center;
        margin-top: 10px;
        margin-bottom: 20px;
        font-weight: 300;
        width: 162px;
        align-items: center;
        justify-content: center;
    `,
    wrapInput: css`
        position: relative;
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        width: 35%;
        p {
            color: #d90500;
            font-weight: 400;
            font-size: 15px;
        }
        input {
            padding: 8px 12px;
            color: black;
            width: 100%;
            height: 40px;
            border: 0;
            border-bottom: 1px solid black;
            &::placeholder {
                font-size: 14px;
                color: #90949c;
                letter-spacing: 0;
            }
        }
    `,
    hintText: css`
        display: inline-block;
        margin-left: 10px;
        color: #999;
        font-size: 13px;
        font-style: italic;
        white-space: nowrap;
    `,
    errorInput: css`
        margin-left: 10px;
        small {
            font-size: 12px;
            color: ${colors.red};
        }
    `,
    bankName: css`
        color: black;
        background-color: white;
        border: 0;
        padding-bottom: 5px;
        border-bottom: 1px solid black;
        width: 35%;
        height: 40px;
    `,
    inputBank: css`
        display: flex;
        align-items: center;
        justify-content: space-between;
    `,
};
export default addBankStyles;
